export default __webpack_public_path__ + "static/media/icon-select-on.bb15fde4.svg";